<div class="menu-workspace" appVenueColour [primaryColour]="venue.primaryColour">
    <header class="menu-workspace__header">
        <h3 id="customer-menu-title" class="menu-title">{{ menu.displayName }}</h3>
        <button type="button" class="btn-close" aria-label="Close menu" (click)="dismiss()"></button>
    </header>
    @if (menuCourseLimitsDisplay) {
        <div class="menu-workspace__context"><strong data-testid="menu-course-limits">{{ menuCourseLimitsDisplay }}</strong></div>
    }
    <div class="menu-workspace__layout">
        <nav class="menu-workspace__nav" aria-label="Menu courses" data-testid="menu-course-navigation">
            <h4 class="menu-workspace__nav-title">Courses</h4>
            @for (courseGroup of courses; track courseGroup.course.id) {
                <div class="menu-workspace__nav-course">
                    <button class="menu-course-link" type="button" (click)="scrollToCourse(courseGroup.course.id)">
                        <span class="menu-course-link__name">{{ courseGroup.course.displayName }}</span>
                        @if (courseGroup.course.excludesFromCourseCount) { <span class="menu-workspace__badge">Extra</span> }
                    </button>
                </div>
            }
        </nav>
        <div class="menu-workspace__body" data-testid="menu-scroll-area">
            @if (menu.description) { <p class="menu-workspace__description">{{ menu.description }}</p> }
            <div class="menu-workspace__courses">
                @for (courseGroup of courses; track courseGroup.course.id) {
                    <section class="menu-course" #courseSection tabindex="-1" [attr.data-course-id]="courseGroup.course.id" [attr.aria-label]="courseGroup.course.displayName">
                        <header class="menu-course__header">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <h4>{{ courseGroup.course.displayName }}</h4>
                                @if (courseGroup.course.excludesFromCourseCount) { <span class="menu-workspace__badge" data-testid="course-extra-badge">Extra</span> }
                            </div>
                            @if (courseGroup.course.description) { <p style="white-space: pre-line" data-testid="course-description">{{ courseGroup.course.description }}</p> }
                            @if (getCourseLimitsDisplay(courseGroup.course); as limits) {
                                <p>{{ limits }}{{ menuCourseLimitsDisplay ? ' if choosing this course' : '' }}</p>
                            }
                        </header>
                        <div class="menu-course__dishes">
                            @for (item of courseGroup.items; track item.menuItem.id) {
                                <article class="menu-dish">
                                    <h5>{{ item.consumable.displayName || 'Item' }}</h5>
                                    @if (item.descriptionFull) {
                                        <p>{{ item.expanded ? item.descriptionFull : item.descriptionShort }}{{ !item.expanded && item.canTruncate ? '…' : '' }}</p>
                                        @if (item.canTruncate) {
                                            <button class="menu-text-action" type="button" [attr.aria-expanded]="item.expanded" (click)="toggleDescription(item)">{{ item.expanded ? 'Read less' : 'Read more' }}</button>
                                        }
                                    }
                                    @if (item.modifierGroups.length > 0) {
                                        <details class="menu-dish__options">
                                            <summary>View options</summary>
                                            @for (group of item.modifierGroups; track group.id) {
                                                <div class="menu-dish__option-group">
                                                    <h6>{{ group.name }}</h6>
                                                    @for (modifier of group.modifiers; track $index) {
                                                        <p>{{ modifier.name }}@if (modifier.description) { <span>— {{ modifier.description }}</span> }</p>
                                                    }
                                                </div>
                                            }
                                        </details>
                                    }
                                </article>
                            } @empty { <p class="text-muted">No dishes in this course yet.</p> }
                        </div>
                    </section>
                }
            </div>
        </div>
    </div>
    <footer class="menu-workspace__footer">
        <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Back to booking</button>
    </footer>
</div>
